// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../css/application.css"

ActiveStorage.start()
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// Make react_ujs work with Turbo navigation
document.addEventListener('turbo:load', () => {
  ReactRailsUJS.mountComponents()
})

document.addEventListener('turbo:before-cache', () => {
  ReactRailsUJS.unmountComponents()
})
